import { Dispatch } from 'redux'
import { Store } from '@reduxjs/toolkit'

import * as CommonActions from '../actions/common.action'
import { IService } from '../../shared/interfaces/service.interface'
import { CommonAction } from '../../shared/interfaces/action.interface'
import { getCommonState } from '../selector/common.selector'

const fetchSignatory =
  ({ log, api, toast }: IService) =>
  ({ dispatch }: Store) =>
  (next: Dispatch) =>
  async (action: CommonAction) => {
    next(action)
    const { type, payload } = action

    if (type === CommonActions.COMMON_FETCH_SIGNATORY) {
      try {
        const { data, success, errors } = await api.common.fetchSignatory(payload)

        if (success) {
          dispatch(CommonActions.CommonFetchSignatoriesSuccess(data))
        } else {
          const [{ message }] = errors

          toast('error', message)
          dispatch(CommonActions.CommonFetchSignatoriesError())
        }
      } catch (error: any) {
        log(error)
      }
    }
  }

const fetchReportFilter =
  ({ log, api, toast }: IService) =>
  ({ dispatch, getState }: Store) =>
  (next: Dispatch) =>
  async (action: CommonAction) => {
    next(action)
    const { type, payload } = action
    const {
      common: {
        filters: { reasons, years },
      },
    } = getState()

    if (type === CommonActions.COMMON_FETCH_REPORT_FILTERS) {
      try {
        if (!reasons || !years) {
          const { data, success, errors } = await api.common.fetchReportFilters()

          if (success) {
            dispatch(CommonActions.CommonFetchReportFiltersSuccess(data))
          } else {
            const [{ message }] = errors

            toast('error', message)
            dispatch(CommonActions.CommonFetchReportFiltersError())
          }
        }
      } catch (error: any) {
        log(error)
      }
    }
  }

const fetchAffiliate =
  ({ log, api, toast }: IService) =>
  ({ dispatch, getState }: Store) =>
  (next: Dispatch) =>
  async (action: CommonAction) => {
    next(action)
    const { type, payload } = action
    const {
      common: {
        company: { items },
      },
    } = getState()

    if (type === CommonActions.COMMON_FETCH_AFFILIATES) {
      try {
        if (!items) {
          const { data, success, errors } = await api.common.fetchCompany()

          if (success) {
            dispatch(CommonActions.CommonFetchAffiliatesSuccess(data))
          } else {
            const [{ message }] = errors

            toast('error', message)
            dispatch(CommonActions.CommonFetchAffiliatesError())
          }
        }
      } catch (error: any) {
        log(error)
      }
    }
  }

const fetchBaseOfAssignment =
  ({ log, api, toast }: IService) =>
  ({ dispatch, getState }: Store) =>
  (next: Dispatch) =>
  async (action: CommonAction) => {
    next(action)
    const { type, payload } = action
    const {
      common: {
        base_of_assignments: { items },
      },
    } = getState()

    if (type === CommonActions.COMMON_FETCH_BASE_OF_ASSIGNMENTS) {
      try {
        if (!items) {
          const { data, success, errors } = await api.common.fetchBaseOfAssignment()

          if (success) {
            dispatch(CommonActions.CommonFetchBaseOfAssignmentsSuccess(data))
          } else {
            const [{ message }] = errors

            toast('error', message)
            dispatch(CommonActions.CommonFetchBaseOfAssignmentsError())
          }
        }
      } catch (error: any) {
        log(error)
      }
    }
  }

const hr = [fetchSignatory, fetchReportFilter, fetchAffiliate, fetchBaseOfAssignment]

export default hr
